import React from 'react';
import { Paper, styled, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Column, Row } from 'ui/Flex';

interface CampaignPaperProps {
    isChecked?: boolean;
    title: string;
}
const PREFIX = 'CampaignPaper';

const classes = {
    root: `${PREFIX}-root`,
    icon: `${PREFIX}-icon`,
    column: `${PREFIX}-column`
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    [`& .${classes.icon}`]: {
        padding: theme.spacing(0, 2, 0, 0)
    },
    [`& .${classes.column}`]: {
        maxWidth: 'fit-content'
    }
}));

export const CampaignPaper: React.FC<CampaignPaperProps> = props => {
    const { children, isChecked, title } = props;
    return (
        <StyledPaper className={classes.root}>
            <Row>
                <Column align="center" valign="center" className={classes.icon}>
                    {isChecked ? (
                        <CheckCircleIcon color="primary" />
                    ) : (
                        <RadioButtonUncheckedIcon color="primary" />
                    )}
                </Column>
                <Column className={classes.column}>
                    <Typography gutterBottom>{title}</Typography>
                    {children}
                </Column>
            </Row>
        </StyledPaper>
    );
};
